// frontend/src/components/event/LocationBadge.js
import React from "react";
import { parseLocation, countryCodeToFlag } from "../../utils/locationUtils";

const LocationBadge = ({ location, size = "md" }) => {
  const { city, countryCode } = parseLocation(location);
  const flag = countryCodeToFlag(countryCode);

  if (!city) return null;

  const sizeClasses = {
    sm: "text-xs px-2 py-1",
    md: "text-sm px-3 py-1",
    lg: "text-base px-3 py-1.5",
  };

  return (
    <span
      className={`inline-flex items-center gap-1 rounded font-bold bg-[#002855] text-white ${sizeClasses[size]}`}
    >
      {flag && <span className="leading-none">{flag}</span>}
      <span>{city}</span>
    </span>
  );
};

export default LocationBadge;
